import React from 'react';
import NumberFormat from 'react-number-format';



export default class BudzetPrint extends React.Component {


sumaall = (data, key) => {
  let total = 0;
  data.forEach((item, idx) => {
    let itemdot = item[key].replace(',', '.');
    let itemnum = parseFloat(itemdot);
    total += itemnum;
    total = parseFloat(total.toFixed(2));
  });
  return total;
};


render() {

const { data, nazwauchwaly } = this.props;

return (<React.Fragment>
<h5 className='mb-3 text-center' >{nazwauchwaly}</h5>
<div class="d-flex justify-content-center w-100">

<table class="table table-bordered">
  <thead>
    <tr>
      <th scope="col" class="text-center point" width="5%" ><b>Dział</b></th>
      <th scope="col" class="text-center point" width="5%" ><b>Rozdział</b></th>
      <th scope="col" class="text-center point" width="5%" ><b>Paragraf</b></th>
      <th scope="col" class="text-center point" width="5%" ><b>Pozycja</b></th>
      <th scope="col" class="text-center point" width="10%" ><b>Rodzaj</b></th>
      <th scope="col" class="text-center point" width="15%" ><b>Wydział</b></th>
      <th scope="col" class="text-center point" width="30%" ><b>Opis</b></th>
      <th scope="col" class="text-center point" width="5%" ><b>Plan ubiegłoroczny</b></th>
      <th scope="col" class="text-center point" width="5%" ><b>Wniosek</b></th>
    </tr>
  </thead>
  <tbody>
  {data.map((user, idx) => {
    const { Rozdzial, Dzial, Paragraf, Rodzaj, Wydzial, Opis, Przed, P4, Pozycja, Wniosek } = user;
    return (<tr key={idx}>
      <td ><p class="text-right">{Dzial}</p></td>
      <td ><p class="text-right">{Rozdzial}</p></td>
      <td ><p class="text-right">{Paragraf}{P4}</p></td>
      <td ><p class="text-right">{Pozycja}</p></td>
      <td ><p>{Rodzaj}</p></td>
      <td ><p>{Wydzial}</p></td>
      <td ><p>{Opis}</p></td>
      <td ><p class="text-right kwoty"><NumberFormat value={Przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
      <td ><div className="d-flex flex-row"><p class="text-right kwoty"><NumberFormat value={Wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></div></td>   
    </tr>)}
  )}
    <tr >
      <td colSpan="7" className="text-right"><b>SUMA:</b></td>
      <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data, 'Przed')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
      <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data, 'Wniosek')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
    </tr>
  </tbody>
</table>
</div>
</React.Fragment>);

}

}

